import { updateResources } from "@/mocks/resources";

const formatIcon: Record<string, string> = {
  网盘: "ri-cloud-line",
  直链: "ri-link-m",
  磁力: "ri-attachment-line",
  秒传: "ri-flashlight-line",
};

const formatStyle: Record<string, string> = {
  网盘: "bg-primary-100 text-primary-700",
  直链: "bg-accent-100 text-accent-700",
  磁力: "bg-secondary-100 text-secondary-900",
  秒传: "bg-accent-100 text-accent-700",
};

export default function Updates() {
  return (
    <section id="updates" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="text-sm font-medium text-accent-600">追更补档</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">最新更新</h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            关注的资源第一时间同步在这里，周更、补档、重制一目了然，追更更省心。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {updateResources.map((r) => (
            <article key={r.id} className="flex flex-col rounded-lg border border-background-200/80 bg-background-100/50 p-4 transition-colors hover:border-accent-300">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-accent-600 ring-1 ring-background-200">
                  <i className={`${formatIcon[r.format]} text-lg`}></i>
                </span>
                <div className="min-w-0">
                  <h3 className="truncate text-sm font-semibold text-foreground-950">{r.title}</h3>
                  <p className="mt-0.5 text-xs text-foreground-500">{r.update}</p>
                </div>
              </div>
              <div className="mt-3 flex flex-wrap items-center gap-2 text-xs">
                <span className={`rounded-full px-2 py-0.5 ${formatStyle[r.format]}`}>{r.format}</span>
                <span className="rounded-full bg-background-200/60 px-2 py-0.5 text-foreground-600">{r.subject}</span>
                <span className="ml-auto text-foreground-500">{r.size}</span>
              </div>
              <p className="mt-3 line-clamp-2 text-xs leading-relaxed text-foreground-600">{r.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}